import { motion } from "framer-motion";

const patologie = [
  {
    gruppo: "Patologie benigne del sangue",
    items: [
      "Anemie (sideropeniche, da malattia cronica, megaloblastiche, emolitiche)",
      "Piastrinopenie e piastrinosi",
      "Leucopenie e leucocitosi reattive",
      "Poliglobulie primitive e secondarie",
    ],
  },
  {
    gruppo: "Oncoematologia",
    items: [
      "Linfomi Hodgkin e non-Hodgkin",
      "Leucemie acute e croniche",
      "Mieloma multiplo e gammapatie monoclonali",
      "Sindromi mieloproliferative e mielodisplastiche",
    ],
  },
];

export default function PatologieTrattate() {
  return (
    <section
      id="patologie"
      data-testid="patologie-section"
      className="py-24 md:py-32 bg-[#EFECE7]"
    >
      <div className="max-w-[1320px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-end mb-16">
          <div className="lg:col-span-7">
            <p className="eyebrow">Patologie trattate</p>
            <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight mt-6 text-[#1A1D1A]">
              Aree cliniche di <span className="italic text-[#8A6D56]">competenza</span>.
            </h2>
          </div>
          <p className="lg:col-span-5 text-base text-[#5C635E] leading-relaxed">
            Diagnosi e presa in carico di patologie ematologiche benigne e oncoematologiche,
            con approccio integrato dalla prima valutazione al follow-up.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {patologie.map((p, i) => (
            <motion.article
              key={p.gruppo}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.55, delay: i * 0.08 }}
              data-testid={`patologia-card-${i}`}
              className="bg-white border border-[#E5E1D8] rounded-2xl p-8 flex flex-col"
            >
              <p className="eyebrow text-[#8A6D56]">Area {String(i + 1).padStart(2, "0")}</p>
              <h3 className="font-serif-display text-[26px] md:text-3xl leading-tight mt-4 text-[#1A1D1A]">
                {p.gruppo}
              </h3>
              <ul className="mt-6 space-y-3 border-t border-[#E5E1D8] pt-6">
                {p.items.map((item) => (
                  <li
                    key={item}
                    className="text-[14px] text-[#1A1D1A]/85 leading-relaxed flex gap-3"
                  >
                    <span
                      className="mt-[9px] w-1 h-1 rounded-full bg-[#8A6D56] shrink-0"
                      aria-hidden
                    />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </motion.article>
          ))}
        </div>

        <p className="mt-10 text-sm text-[#5C635E] max-w-3xl">
          L&apos;elenco è indicativo. Per una valutazione specifica del proprio quadro
          clinico è consigliata una visita specialistica dedicata.
        </p>
      </div>
    </section>
  );
}
